import React from "react"
import styled from "styled-components"
import { down } from "styled-breakpoints"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { motion, AnimatePresence } from "framer-motion"

import { Div } from "../../utils/utils"
import { H3, Text } from "../../utils/typo"
import { theme } from "../../utils/theme"
import { faAngleDown, faAngleUp } from "@fortawesome/free-solid-svg-icons"

const CennikRow = styled.tr`
  background-color: ${props => props.bgcolor || props.theme.color.grey9};
  th {
    text-align: center !important;
    padding: 0.7rem;
    p {
      text-transform: uppercase;
      text-align: center;
      line-height: 1;
      white-space: pre-wrap;
      word-break: break-all;

      ${down("sm")} {
        font-size: 22px;
      }

      ${down("xs")} {
        font-size: 18px;
      }
    }

    label {
      font-weight: 100;
      display: block;
      text-align: center;
      white-space: pre-wrap;
      color: ${props => props.theme.color.grey6};

      ${down("xs")} {
        display: none;
      }
    }
  }

  button {
    background-color: transparent;
    color: black;
    font-size: 25px;
    padding: 0 0.5rem;

    :hover {
      color: red;
    }

    :focus {
      border: none;
    }
  }
`

const Cell = styled.td`
  padding: 0.5rem;

  label {
    display: block;
    text-align: center;
  }

  div {
    display: flex;
    justify-content: space-between;
    align-content: flex-start;

    p:nth-last-of-type(1) {
      text-align: left;
      margin-left: 0.2rem;
    }

    label:nth-of-type(1) {
      margin-top: 0.3rem;
      display: inline-block;
      margin-left: 0.2rem;
      white-space: pre-wrap;
      line-height: 1.1;
      text-align: left;
    }

    p {
      text-transform: uppercase;
      font-weight: 900;
      word-break: break-all;
    }
  }
  p {
    text-align: center;
    line-height: 1.2;
    white-space: pre-wrap;
  }
`

class AccordionCardCennik extends React.Component {
  state = { clicked: false }

  handleClick = () => {
    this.setState({ clicked: !this.state.clicked })
  }

  render() {
    return (
      <>
        {/*MENU ROZWIJANE*/}

        <CennikRow
          bgcolor={this.props.id % 2 ? "transparent" : theme.color.grey8}
        >
          <Cell as={this.props.id === 1 ? "th" : "td"}>
            <div>
              <span>
                <Text>{this.props.col1}</Text>
                <label>{this.props.col1label}</label>
              </span>

              {this.props.rozwijanie === true ? (
                <button onClick={this.handleClick} state={this.state.clicked}>
                  {this.state.clicked ? (
                    <FontAwesomeIcon icon={faAngleUp} />
                  ) : (
                    <FontAwesomeIcon icon={faAngleDown} />
                  )}
                </button>
              ) : (
                <></>
              )}
            </div>
          </Cell>

          {this.props.col2 === undefined ? (
            <></>
          ) : (
            <Cell as={this.props.id === 1 ? "th" : "td"}>
              {this.props.id === 1 ? (
                <H3 as="p">{this.props.col2}</H3>
              ) : (
                <Text>{this.props.col2}</Text>
              )}
              <label>{this.props.col2label}</label>
            </Cell>
          )}

          {this.props.col3 === undefined ? (
            <></>
          ) : (
            <Cell as={this.props.id === 1 ? "th" : "td"}>
              {this.props.id === 1 ? (
                <H3 as="p">{this.props.col3}</H3>
              ) : (
                <Text>{this.props.col3}</Text>
              )}
              <label>{this.props.col3label}</label>
            </Cell>
          )}
          {this.props.col4 === undefined ? (
            <></>
          ) : (
            <Cell as={this.props.id === 1 ? "th" : "td"}>
              {this.props.id === 1 ? (
                <H3 as="p">{this.props.col4}</H3>
              ) : (
                <Text>{this.props.col4}</Text>
              )}
              <label>{this.props.col4label}</label>
            </Cell>
          )}
          {this.props.col5 === undefined ? (
            <></>
          ) : (
            <Cell as={this.props.id === 1 ? "th" : "td"}>
              {this.props.id === 1 ? (
                <H3 as="p">{this.props.col5}</H3>
              ) : (
                <Text>{this.props.col5}</Text>
              )}
              <label>{this.props.col5label}</label>
            </Cell>
          )}
          {this.props.col6 === undefined ? (
            <></>
          ) : (
            <Cell as={this.props.id === 1 ? "th" : "td"}>
              {this.props.id === 1 ? (
                <H3 as="p">{this.props.col6}</H3>
              ) : (
                <Text>{this.props.col6}</Text>
              )}
              <label>{this.props.col6label}</label>
            </Cell>
          )}
          {this.props.col7 === undefined ? (
            <></>
          ) : (
            <Cell as={this.props.id === 1 ? "th" : "td"}>
              {this.props.id === 1 ? (
                <H3 as="p">{this.props.col7}</H3>
              ) : (
                <Text>{this.props.col7}</Text>
              )}
              <label>{this.props.col7label}</label>
            </Cell>
          )}
          {this.props.col8 === undefined ? (
            <></>
          ) : (
            <Cell as={this.props.id === 1 ? "th" : "td"}>
              {this.props.id === 1 ? (
                <H3 as="p">{this.props.col8}</H3>
              ) : (
                <Text>{this.props.col8}</Text>
              )}
              <label>{this.props.col8label}</label>
            </Cell>
          )}
        </CennikRow>

        {/*ROZWINIĘCIE*/}

        <AnimatePresence initial={false}>
          {this.state.clicked && (
            <motion.tr
              key="content"
              initial="collapsed"
              animate="open"
              exit="collapsed"
              variants={{
                open: { opacity: 1 },
                collapsed: { opacity: 0 },
              }}
              transition={{ duration: 0.3 }}
            >
              <td colSpan="6">
                <Div pt="1rem" pb="1rem" pl=".7rem" pr=".7rem">
                  <Text>{this.props.text}</Text>
                </Div>
              </td>
            </motion.tr>
          )}
        </AnimatePresence>
      </>
    )
  }
}
export default AccordionCardCennik
